import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import { fetchServiceType } from "../../features/serviceType/serviceTypeActions";
import { updateServiceTypeFilter } from "../../features/serviceTypeFilter/selectedServiceTypeActions";
import { ApplicationState } from "../../redux/initialState";
import { ServiceType } from "../../features/serviceType/serviceTypeTypes";
import { SelectedServiceType } from "../../features/serviceTypeFilter/selectedServiceTypeTypes";
import { Checkbox, useBreakpoint } from "@tal-gel/components-v2";

interface PropsFromState {
  loading: boolean;
  data: ServiceType[];
  errors?: string;
}

interface propsFromDispatch {
  fetchServiceType: () => any;
  updateServiceTypeFilter: (ServiceTypeFilter: any) => any;
}

type AllProps = PropsFromState & propsFromDispatch;

const ServiceTypeBox: React.FC<AllProps> = ({ data, fetchServiceType, updateServiceTypeFilter }) => {
  //needed to remember values when open / close mobile modal
  const values = useSelector<ApplicationState, string[]>(state => state.selectedServiceType.data as string[]);

  useEffect(() => {
    if (!data.length) {
      fetchServiceType();
    }
  }, [data.length, fetchServiceType]);

  const UpdateFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedServiceType: SelectedServiceType = {
      id: e.target.id,
      isChecked: e.target.checked,
    };
    updateServiceTypeFilter(selectedServiceType);
  };

  const isLargerThanMdScreen = useBreakpoint("md");
  const isSmOrSmaller = !useBreakpoint("sm");

  return (
    <CheckboxGroup>
      <ColumnLayout columns={isSmOrSmaller ? 1 : isLargerThanMdScreen ? 3 : 2}>
        {data.map(item => (
          <Checkbox
            key={item.id}
            id={item.id}
            value={item.externalName}
            checked={values.includes(item.id)}
            onChange={UpdateFilter}
            labelRight={item.externalName}
            colorScheme="default"
          />
        ))}
      </ColumnLayout>
    </CheckboxGroup>
  );
};

const mapStateToProps = ({ serviceType }: ApplicationState) => ({
  loading: serviceType.loading,
  errors: serviceType.errors,
  data: serviceType.data,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    fetchServiceType: () => {
      dispatch(fetchServiceType());
    },
    updateServiceTypeFilter: (selectedServiceType: SelectedServiceType) => {
      dispatch(updateServiceTypeFilter(selectedServiceType));
    },
  };
};

ServiceTypeBox.propTypes = {
  loading: PropTypes.any,
  data: PropTypes.any.isRequired,
  errors: PropTypes.string,
  fetchServiceType: PropTypes.func.isRequired,
  updateServiceTypeFilter: PropTypes.func.isRequired,
};

const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ColumnLayout = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.columns}, 1fr);
  gap: 16px;
`;

export default connect(mapStateToProps, mapDispatchToProps)(ServiceTypeBox);
